'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import CmsMasterContainerV2, { CmsMasterContainerV2Props } from 'components/commercetools-ui/organisms/content/cms-master-container-v2';

/**
 * Renders the bound Contentstack `generic_page_v2` entry.
 *
 * A previous client-side preview branch here fetched `/{locale}/v2-migration-data?slug=...` on the
 * `v2-migration-test` route. Neither that API route nor `public/v2-migration/` was ever committed,
 * so it always resolved to `{ sections: [] }` and rendered nothing. It has been removed rather than
 * repaired: a client fetch runs after `resolveCmsProductListingDatasets`, so a previewed
 * `section_with_product_listing` could never get its server-preloaded dataset, and the preview
 * would exercise a different code path from production.
 *
 * Migration previews are now injected server-side in `app/[locale]/[[...slug]]/page.tsx` via
 * `helpers/dev/v2-migration-harness` (`?v2preview=<slug>`, dev-only), which substitutes the data
 * source before the PLP resolver runs -- so a preview renders through exactly this component and
 * exactly the production pipeline.
 */
const CmsMasterContainerV2Tastic = ({ data, categories }: TasticProps<CmsMasterContainerV2Props>) => (
  <CmsMasterContainerV2 data={data?.data?.dataSource} />
);

export default CmsMasterContainerV2Tastic;
